/* istanbul ignore file */
import React from 'react';
import classnames from 'classnames';
import Loading, { LoaderSize } from './Loading';
import Box from '@mui/material/Box';

const SmallLoader = ({ className, size }: { className?: string; size?: string }) => {
  return (
    <Box
      className={classnames('small-loader', className)}
      sx={{ display: 'inline-flex', '& .loading': { position: 'static', width: '20px', display: 'inline-flex' } }}
    >
      <Loading size={size || LoaderSize.Small} />
    </Box>
  );
};

export default SmallLoader;
